export default __webpack_public_path__ + "static/media/workspacesLogo2020-white.5b328fb0.svg";